import { JSX } from 'react'

import { Box, VStack, EmptyState } from '@chakra-ui/react'

import { LuAirplay } from 'react-icons/lu'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/layout.tsx'



// eslint-disable-next-line @typescript-eslint/naming-convention
export function Main (): JSX.Element
{
	return (
		<Box h="full" pt="48" rounded="md" bg="white" shadow="sm">
			<EmptyState.Root>
				<EmptyState.Content>
					<EmptyState.Indicator>
						<LuAirplay />

					</EmptyState.Indicator>

					<VStack textAlign="center">
						<EmptyState.Title>欢迎使用「蓝色海棠」信息管理系统</EmptyState.Title>

						<EmptyState.Description>您可以在此开始您的工作</EmptyState.Description>

					</VStack>

				</EmptyState.Content>

			</EmptyState.Root>

		</Box>

	)

}


export default function (): JSX.Element
{
	return (
		<>
			<Layout.Header breadcrumb={['仪表盘']} />

			<Layout.Main>
				<Layout.Section>
					<Main />

				</Layout.Section>

			</Layout.Main>

		</>

	)

}
